import { render, staticRenderFns } from "./FormTemplateDataTable.vue?vue&type=template&id=2ccfbe02"
import script from "./FormTemplateDataTable.vue?vue&type=script&lang=ts"
export * from "./FormTemplateDataTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports